import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getProcedureId } from 'modules/StrongCustomerAuthentication/redux/selectors';
import { type ScaState } from 'modules/StrongCustomerAuthentication/types';
import { ApproverModalStep } from 'src/core/common/components/WireTransferModal/WireTransferApproverModal';
import { type AuthenticationFactor } from 'src/core/modules/authentication-factor/models/authenticationFactors';

import { ScaWireTransferConfirmationModal } from './ScaWireTransferConfirmationModal';
import { useScaProcedure } from './useScaProcedure';

interface Props {
  isOpen: boolean;
  onUseAlternateMethod: () => void;
  onScaProceed: (state: ScaState) => void;
  onClose: () => void;
  factors: AuthenticationFactor[];
  setCurrentStep: (step: number) => void;
}

export const ScaWireTransferConfirmationModalContainer = ({
  isOpen,
  onUseAlternateMethod,
  onScaProceed,
  onClose,
  factors,
  setCurrentStep,
}: Props) => {
  const procedureId = useSelector(getProcedureId);
  const scaProcedure = useScaProcedure({
    procedureId,
    shouldRefresh: isOpen,
    shouldFetch: Boolean(procedureId),
  });

  useEffect(() => {
    if (isOpen) {
      if (scaProcedure.status === 'success') {
        onScaProceed(scaProcedure.data.scaProcedure.state);
      } else if (factors.length === 0) {
        setCurrentStep(ApproverModalStep.ScaEnrollment);
      }
    }
  }, [scaProcedure, isOpen]);

  return (
    <ScaWireTransferConfirmationModal
      isOpen={isOpen}
      onUseAlternateMethod={onUseAlternateMethod}
      onClose={onClose}
      isScaNotWorking={scaProcedure.status !== 'success'}
    />
  );
};
